import PropTypes from 'prop-types'

import { addressPropTypes } from '../../../common/propTypes'
import { Link, Divider, Box } from '@mui/material'
import AddressSection from './AddressSection'
import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const AddressSectionDestination = ({ data, onClickChange }) => {
  const t = useTranslations()
  return (
    <>
      <AddressSection
        title={t('shipping-send-form:destination-mobile')}
        data={data}
        isDestination
      >
        <Box sx={styles.addresSectionButtonWrapper}>
          <Divider sx={styles.addresSectionDivider} />
          {/* TODO: @pepe este enlace de cambiar dirección tiene que pintarse tanto en origen como en destino,
                    una vez funcione la lógica para ambas direcciones, le doy el repaso final para que quede ajustado visualmente
          */}
          <Link component="button" onClick={onClickChange}>
            {t('action:change')}
          </Link>
        </Box>
      </AddressSection>
    </>
  )
}

AddressSectionDestination.propTypes = {
  data: addressPropTypes,
  onClickChange: PropTypes.func,
}

export default AddressSectionDestination
